package com.htmlagent.site.state

import kotlinx.browser.window
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

/**
 * Whether the browser will install HAL as an app, and the one call that opens its dialog.
 *
 * Chromium fires `beforeinstallprompt` once it judges the site installable and not yet installed;
 * keeping that event is the only way to open the dialog from a button of ours, and cancelling it
 * swaps Chrome's own banner for that button. Safari fires nothing, so there the button never
 * shows. [listen] runs before the first render because the event does not wait for one.
 */
object InstallPrompt {

    private var deferred: dynamic = null

    private val state = MutableStateFlow(false)
    val available: StateFlow<Boolean> = state.asStateFlow()

    fun listen() {
        window.addEventListener("beforeinstallprompt", { event ->
            event.preventDefault()
            deferred = event
            state.value = true
        })
        window.addEventListener("appinstalled", {
            deferred = null
            state.value = false
        })
    }

    /** Opens the browser's install dialog. The event can be used once, so it is spent here. */
    fun prompt() {
        val event = deferred ?: return
        deferred = null
        state.value = false
        event.prompt()
    }
}
